import { Component, OnInit } from '@angular/core';
import { SidenavService } from '@services/sidenav.service';
import { SidebarItem } from '@shared/sidebaritem';
import { sidebarItems } from './menu';

@Component({
	selector: 'app-print',
	templateUrl: './print.component.html',
	styleUrls: ['./print.component.scss'],
	standalone: false,
})
export class PrintComponent implements OnInit {
	public sidebarItems: SidebarItem[] = sidebarItems;

	constructor(private sidenavService: SidenavService) {}

	ngOnInit(): void {
		this.sidenavService.setMenuData(this.sidebarItems);
		void this.sidenavService.closeRightPanel();
	}
}
